// i18n area 'backups' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.hy-AM.meta.json.
import type { enUS } from './backups'

export const hyAM: typeof enUS = {
  ckpt: {
    contents: 'Ընդունում է',
    contentsHint:
      'Ինչը կարող է վայրէջք կատարել այստեղ։ «Checkpoints»-ը կլաստերի կարգավորումն է, «Տվյալների պահուստային պատճենները»՝ ՎՄ-ներինը․ երկու ընթերցումները գումարվում են, մեկ նշանակետ կարող է ընդունել երկուսն էլ։',
    content: { checkpoints: 'Checkpoints', backups: 'Տվյալների պատճեններ' },
    destinationsTitle: 'Կրկնօրինակման նպատակակետեր',
    checkpointsTitle: 'Checkpoint-ներ',
    restoreTitle: 'Վերականգնում',
    addDestination: 'Ավելացնել թիրախ',
    addDestinationTitle: 'Ավելացնել կրկնօրինակման նպատակակետ',
    editDestinationTitle: 'Խմբագրել թիրախը',
    storage: 'Պահոց',
    storageHint:
      'Dir-անման պահոց (dir/NFS/CIFS/CephFS) — արտեֆակտները սովորական ֆայլեր են պլատֆորմի անվանատարածքի տակ։',
    schedule: 'Ժամանակացույց',
    scheduleNone: 'Միայն ձեռքով',
    scheduleHourly: 'Ամեն ժամ',
    scheduleDaily: 'Ամենօրյա',
    scheduleWeekly: 'Շաբաթական',
    scheduleHour: 'Ժամ',
    scheduleWeekday: 'Օր',
    scheduleHint:
      'Ժամանակացույցով checkpoint-ները չունեն օպերատոր, որ մուտքագրի masterpass-ը. բանալիների պահոցի գաղտնիքները փաթեթավորվում են որպես տեղապահներ։',
    retention: 'Պահպանում',
    retentionHint:
      'Քանի ժամանակացույցային checkpoint պահել — մաքրողը հեռացնում է քանակից դուրս ամենահները։ Ձեռքով և նախավերականգնման checkpoint-ները երբեք չեն հեռացվում։',
    paused: 'Դադարեցված է',
    pausedHint:
      'Օպերատորի blackout-ը․ քանի դեռ դադարը տևում է, այս նշանակետում ոչինչ չի պլանավորվում և ոչինչ չի էտվում — թե՛ տվյալների քաղաքականությունները, թե՛ checkpoint-ները։ Ընթացքի մեջ գտնվող կատարումները երբեք չեն դիպչվում։',
    orphanRuns: '{n} որբ աշխատարկում',
    orphanRunsHint:
      'Պլանավորված աշխատարկումներ policy-ներից, որոնք այլևս չկան այս նպատակակետում. ոչ մի retention դրանք չի կառավարում — երբեք չեն հաշվվում, երբեք չեն էտվում — և միայն ձեռքն է դրանք ջնջում: tvirt diagnose-ի «backups» ոսպնյակը անվանում է հեռացված policy-ները:',
    rescan: 'Կրկին ընդունել արտեֆակտները',
    rescanTitle: '{name}-ի արտեֆակտների կրկնակի ընդունում',
    rescanHint:
      'Վերակառուցում է պահուստային կրկնօրինակների կատալոգը (VM/CT/App) նշանակման վայրի արտեֆակտների մանիֆեստներից: Գոյություն ունեցող տողերին երբեք չի դիպչում. անհայտ քաղաքականությունների կրկնօրինակները մնում են որբ (երբեք ինքնաբերաբար չեն էտվում): Քայլը bootstrap վերականգնումից հետո:',
    masterpassDrWarning:
      'Աղետի սցենար. LUKS սկավառակները վերադառնում են ՄԻԱՅՆ masterpass-ով checkpoint-ից: Պլանավորված checkpoint-ները փաթեթավորում են տեղապահներ — պարբերաբար վերցրեք ձեռքով checkpoint masterpass-ով:',
    policy: {
      title: 'Տվյալների կրկնօրինակման քաղաքականություններ',
      hint: 'Անվանված քաղաքականություններ․ որ օբյեկտները (kind, թեգեր, սկոուպ), որքան հաճախ, երբ կարող է կատարումը մեկնարկել, և քանի պատճեն պահել։ Գրանցման ժեստը մնում է օբյեկտի սեփականատիրոջը․ թեգերը նշանակվում են նրա սեփական սկոուպի վրա։',
      add: 'Ավելացնել քաղաքականություն',
      column: 'Տվյալների քաղաքականություններ',
      name: 'Անուն',
      nameHint:
        'Policy-ի պիտակը՝ եզակի նպատակակետի ներսում: Աշխատարկումները հետևում են policy-ի կայուն id-ին. վերանվանելն անվճար է, ջնջելը նրա աշխատարկումները դարձնում է որբ (այլևս չեն հաշվվում և չեն էտվում):',
      kindLocked: 'Գոյություն ունեցող policy-ի օբյեկտների ընտանիքը չի փոխվում. ստեղծեք նոր policy:',
      kindLabel: 'Օբյեկտներ',
      kind: { vm: 'Վիրտուալ մեքենաներ', ct: 'Կոնտեյներներ', app: 'Հավելվածներ' },
      tags: 'Թեգերի ընտրիչ',
      tagsHint:
        'tag=արժեք զույգեր՝ ստորակետով բաժանված, AND կապով։ Դատարկ թեգերն ու սկոուպները ոչինչ չեն ընտրում — երբեք «ամեն ինչ»։',
      scopes: 'Սկոուպներ',
      scopesHint: 'Սկոուպի ուղիներ (ենթածառեր)՝ ստորակետով բաժանված, միմյանց հետ OR կապով։',
      windowStart: 'Պատուհանը՝ սկսած',
      windowEnd: 'Պատուհանը՝ մինչև',
      windowHint:
        'Կատարման պատուհան (HH:MM, տեղական ժամանակ․ վերջից անդին սկիզբը ցատկում է կեսգիշերի վրայով)։ Կառավարում է միայն ՄԵԿՆԱՐԿԸ․ պատուհանը գերազանցող կատարումը երբեք չի սպանվում։',
      mode: 'Ռեժիմ',
      modeHint: 'Ինկրեմենտալը հեծնում է շարքերի ընտանիքը․ կոտրված շարքը դեգրադացվում է full-ի, ասված մատյանում։',
      modeFull: 'Full',
      modeIncremental: 'Ինկրեմենտալ',
      requireQuiesce: 'Պահանջել quiesce (guest agent)',
      paused: 'Քաղաքականությունը դադարեցված է',
      retentionNone: 'Պահել ամեն ինչ',
      retentionCount: 'Քանակ',
      retentionGfs: 'GFS օղակներ',
      gfs: { keepLast: 'Վերջինները', daily: 'Օրական', weekly: 'Շաբաթական', monthly: 'Ամսական', yearly: 'Տարեկան' },
      gfsHint:
        'Յուրաքանչյուր օղակի համար պահվում է վերջին N ժամանակաշրջաններից յուրաքանչյուրի ամենանոր կրկնօրինակը։ Պահված կրկնօրինակը կենդանի է պահում իր ամբողջ շղթան — երբեք բազա՝ որբերով։',
      lastRun: 'Վերջին կատարումը',
      neverRan: 'երբեք չի կատարվել'
    },
    lastCheckpoint: 'Վերջին checkpoint-ը',
    neverRun: 'Երբեք չի ստեղծվել',
    createNow: 'Ստեղծել checkpoint',
    createNowTitle: 'Ստեղծել checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Պաշտպանում է բանալիների պահոցի գաղտնի արժեքները (argon2id → AES-256-GCM, ամեն արժեքի համար)։ Այն երբեք չի պահվում. պահեք այն — առանց դրա վերականգնումը կտա տեղապահներ՝ իրական գաղտնիքների փոխարեն։',
    masterpassEmptyHint: 'Թողեք դատարկ՝ գաղտնիքների փոխարեն բացահայտ տեղապահներ փաթեթավորելու համար։',
    createStarted: 'Checkpoint-ի ստեղծումն ընթացքի մեջ է…',
    destinationInUseError: "'{name}'-ը դեռ checkpoint-ներ է պարունակում — նախ ջնջեք դրանք։",
    origin: 'Ծագում',
    originManual: 'ձեռքով',
    originSchedule: 'ժամանակացույցով',
    originPreRestore: 'նախավերականգնում',
    originPreChange: 'նախքան փոփոխությունը',
    preChangeRetention: 'Checkpoint-ներ նախքան փոփոխությունը',
    preChangeRetentionHint:
      'Դատարկ = անջատված է։ Հանդարտ ժամանակահատվածից հետո առաջին կոնֆիգուրացիոն գրառումը այստեղ սառեցնում է նախորդ վիճակը (ծագումը՝ «նախքան փոփոխությունը»); ամենանորերը պահվում են մինչև քանակը — սեփական, էտվող ռետենցիա։',
    diffTitle: 'Փոփոխությունների նախադիտում',
    diffFailed: 'Նախադիտումը ձախողվեց',
    diffRetry: 'Կրկին փորձել',
    diffCounts: '{changed} կփոխվի · {missing} կստեղծվի · {extra} ավելորդ · {equal} նույնական',
    diffChanged: 'փոխվում է',
    diffMissing: 'կստեղծվեր',
    diffExtra: 'կջնջվեր',
    diffJsonb: 'jsonb հղումները հնարավոր չէ ստուգել կիրառումից առաջ',
    diffSecret: 'կնքված դաշտեր, անհամեմատելի',
    diffMore: 'եւս {n}…',
    diffNeeded: 'Մեկնարկը ակտիվանում է, երբ նախադիտումը արտացոլում է ընտրությունը։',
    phase: 'Վիճակ',
    phaseRunning: 'ընթացքի մեջ',
    phaseComplete: 'ավարտված',
    phaseError: 'սխալ',
    secrets: 'Գաղտնիքներ',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'տեղապահներ',
    size: 'Չափ',
    created: 'Ստեղծված',
    destination: 'Թիրախ',
    download: 'Ներբեռնել .tvbk',
    deleteCheckpoint: 'Ջնջել checkpoint-ը',
    noCheckpoints: 'Checkpoint-ներ չկան — ստեղծեք մեկը որևէ նպատակակետից։',

    // Ռաունդ #156 (ստանդարտ երկխոսություն). արխիվի գրառման ամբողջական
    // ընթերցման մակերեսը — մանրամասների տողեր աղյուսակում երբեք չցուցադրված դաշտերի համար:
    families: 'Ընտանիքներ',
    generation: 'Սերունդ',
    completedAt: 'Ավարտվել է',
    errorDetail: 'Սխալի մանրամասն',
    manifest: 'Մանիֆեստ',
    restoreHint:
      'Վերբեռնեք .tvbk արտեֆակտ. դիտարկիչը ցույց է տալիս, թե ինչ է այն կրում, ապա ընտրում եք՝ ինչ վերականգնել և ինչպես։',
    uploadFile: 'Վերբեռնել .tvbk ֆայլ',
    uploading: 'Վերբեռնում…',
    uploadFailed: 'Չհաջողվեց բացել արտեֆակտը',
    explorerTitle: 'Checkpoint-ի բովանդակությունը',
    checkpointFrom: '{cluster} կլաստերի checkpoint, ստեղծված {when} ({origin}, սերունդ՝ {generation})',
    otherCluster:
      'Այս checkpoint-ը ստեղծվել է ՄԵԿ ԱՅԼ կլաստերի վրա ({cluster}) — միջկլաստերային վերականգնումը ապագա ռաունդի գործ է։',
    encrypted: 'գաղտնագրված',
    objectsCount: '{n} օբյեկտ',
    mode: 'Ռեժիմ',
    modeMerge: 'Merge — հաշտեցնում. ընտրված տողերի upsert, ոչինչ չի ջնջվում',
    modeOverwrite:
      'Overwrite — հաղթում է checkpoint-ը. ամբողջությամբ ընտրված ընտանիքը փոխարինվում է ամբողջովին (checkpoint-ում բացակայող ընթացիկ տողերը մեռնում են)',
    restoreMasterpassHint:
      'Masterpass-ը, որով ստեղծվել է այս checkpoint-ը։ Առանց դրա գաղտնագրված գաղտնիքները վերականգնվում են որպես բացահայտ տեղապահներ։',
    checkMasterpass: 'Ստուգել',
    masterpassOk: 'Masterpass-ը ճիշտ է',
    masterpassWrong: 'Masterpass-ը սխալ է',
    parachuteDestination: 'Պարաշյուտային նպատակակետ',
    parachuteHint: 'Որևէ տողի դիպչելուց առաջ առաջադրանքն այստեղ ստեղծում է ավտոմատ նախավերականգնման checkpoint։',
    summaryTitle: 'Ինչ է լինելու',
    summaryLine: '{family}՝ {what} — {mode}',
    summaryWhole: 'ամբողջ ընտանիքը',
    summaryObjects: '{n} ընտրված օբյեկտ',
    confirmHint:
      'Հաստատելու համար մուտքագրեք կլաստերի անունը ({name}) — վերականգնումը վերագրում է հայտարարված կոնֆիգուրացիան։',
    confirmField: 'Կլաստերի անունը',
    startRestore: 'Վերականգնել',
    restoreRunning: 'Վերականգնումն ընթացքի մեջ է…',
    restoreDone: 'Վերականգնումն ավարտված է — հաշտեցնողները զուգամիտում են նոր հայտարարագրին։',
    restoreFailed: 'Վերականգնումը ձախողվեց',
    discard: 'Դեն նետել',
    selectionEmpty: 'Ընտրեք առնվազն մեկ ընտանիք կամ օբյեկտ։'
  },

  backup: {
    intro: {
      title: 'VM-ների և կոնտեյներների տվյալների կրկնօրինակում',
      subtitle: 'Շինաքարերը, որոնք օգտագործում են արտաքին կրկնօրինակման ծրագրերը',
      whatItIs:
        'TVirt-ը տրամադրում է չորս պրիմիտիվ. quiesced սնապշոթներ, փոփոխությունների հետագծում ըստ սկավառակի, միայն ընթերցման NBD արտահանում և կոնֆիգուրացիայի արտահանում։ Դրանք վարում են Veeam-ը, Bacula-ն, Acronis-ը և նմանները։',
      whatItIsNot:
        'TVirt-ը կրկնօրինակման արտադրանք չէ. ոչինչ չի պլանավորում, պահպանման քաղաքականություն չի կիրառում և ձեր տվյալների ոչ մի արխիվ չի պահում։ Պահպանումը, կատալոգները և վերականգնման քաղաքականությունները մնում են այն ծրագրին, որն արդեն օգտագործում եք։'
    },
    cbt: {
      title: 'Փոփոխությունների հետևում',
      colVm: 'VM',
      colDisk: 'Սկավառակ',
      colState: 'Վիճակ',
      colBitmaps: 'Բիթմափեր',
      colObservedAt: 'Դիտարկված',
      colChangeId: 'Change ID',
      colMechanic: 'Մեխանիզմ',
      stateActive: 'Ակտիվ',
      stateInactive: 'Անջատված',
      stateInconsistent: 'Անհամապատասխան — հաջորդ պահուստը պետք է լինի լրիվ',
      stateBroken: 'Շղթան ընդհատված է — անջատեք, ապա միացրեք որպես նոր շղթա',
      stateSnapshots: 'Միշտ միացված — delta ակնթարթային պատկերների միջև',
      stateUnavailable: 'Այս սկավառակի վրա հասանելի չէ',
      mechanic: {
        'qcow2-bitmap': 'qcow2 բիթմափ',
        'rbd-snapdiff': 'Ceph պատկերների diff',
        'lvm-thin-delta': 'Thin pool delta',
        none: 'Չկա'
      },
      empty:
        'VM սկավառակ չկա։ Հետևումը կարդացվում է ըստ սկավառակի․ միացրեք qcow2 սկավառակի վրա կամ ստեղծեք պատկերներ rbd/SAN-ում։',
      chainBroken: 'Շղթան ընդհատված է',
      chainBrokenText:
        'Ընդհատվել է {reason}-ի պատճառով՝ {bitmaps}։ Անջատեք բիթմափը (շղթան կորած է, հաջորդ պահուստը լրիվ է), ապա միացրեք որպես նոր շղթա։',
      lineages: 'Դարաշրջաններ',
      epochFrozen: 'սառեցված {snapshot} պատկերում',
      epochLost: 'կորած ({cause})',
      epochRecording: 'գրանցում է գլխում',
      milestones: 'Հանգրվաններ (պատկերներ)',
      enable: 'Միացնել հետևումը',
      disable: 'Անջատել',
      reset: 'Զրոյացնել',
      changedAreas: 'Փոփոխված տիրույթներ',
      denied: 'Դուք չունեք թույլտվություն այս VM-ում',
      enableTitle: 'Միացնել փոփոխությունների հետևումը',
      disableTitle: 'Անջատել փոփոխությունների հետևումը',
      resetTitle: 'Զրոյացնել բիթմափը',
      areasTitle: 'Փոփոխված տիրույթներ',
      bitmapName: 'Բիթմափի անուն',
      bitmapNameHint: 'Ձեր անունը՝ tvirt- և tvbk- պատկանում են հարթակին',
      granularity: 'Հատիկայնություն (բայթ)',
      granularityHint: 'Երկուսի աստիճան․ լռելյայն 65536',
      bitmap: 'Բիթմափ',
      disableHint: 'Հեռացնում է բիթմափը և նրա դարաշրջանների ամբողջ պատմությունը․ հաջորդ պահուստը պետք է լինի լրիվ։',
      resetHint: 'Դատարկում է բիթմափը — նոր հիմք․ զրոյացումից հին change ID-ն այլևս չի կազմվում։',
      areasFrom: 'Պատկերից',
      areasTo: 'Մինչև պատկեր',
      areasRun: 'Հաշվել',
      areasResult: '{count} փոփոխված տիրույթ, {bytes}',
      areasEmpty: 'Երկու պատկերների միջև փոփոխված տիրույթ չկա',
      areasZero: 'զրոներ',
      areasMore: 'ցուցադրված են առաջին {shown}-ը {count}-ից',
      submit: 'Հաստատել',
      error: 'Հետևման գործողությունը ձախողվեց'
    },
    exports: {
      title: 'Բաց NBD արտահանումներ',
      colVm: 'VM',
      colDisk: 'Սկավառակ',
      colSnapshot: 'Պատկեր',
      colBitmap: 'Բիթմափ',
      colPhase: 'Փուլ',
      colNode: 'Հանգույց',
      colEndpoint: 'Endpoint',
      colExpires: 'Լրանում է',
      colCreated: 'Բացված',
      colError: 'Սխալ',
      phase: {
        preparing: 'Նախապատրաստվում է',
        ready: 'Պատրաստ',
        closed: 'Փակված',
        error: 'Ձախողված'
      },
      expiresIn: '{minutes} րոպեից',
      expired: 'լրացած',
      empty: 'Արտահանում չկա։ Ընթերցման նստաշրջանը մեկ սկավառակ է մատուցում մեկ պատկերում NBD հաճախորդին. գրառման նստաշրջանը լցնում է կանգնեցված VM-ի անձեռնմխելի սկավառակը։ Երկուսն էլ մահանում են ժամկետի ավարտին։',
      endpointHint: 'TLS կլաստերի CA-ով․ արտահանման անունը տոմսն է — մահանում է նստաշրջանի հետ',
      closeDenied: 'Դուք չունեք թույլտվություն փակելու այս VM-ի արտահանումները',
      open: 'Բացել NBD արտահանում',
      openTitle: 'Բացել NBD արտահանում',
      openDisk: 'Սկավառակ',
      openBitmap: 'Բիթմափ (ըստ ցանկության)',
      openBitmapHint:
        'Հրապարակում է այդ բիթմափի՝ այս պատկերում սառեցված դարաշրջանը որպես փոփոխված extent-ների meta-context (միայն qcow2 սկավառակներ)',
      openTtl: 'Տևողություն (րոպե)',
      openSubmit: 'Բացել',
      openError: 'Արտահանումը չհաջողվեց բացել',
      colMode: 'Ռեժիմ',
      mode: {
        read: 'Ընթերցում',
        write: 'Գրառում'
      },
      caCertificate: 'Կլաստերի CA',
      caCopy: 'Պատճենել PEM',
      caDownload: 'Ներբեռնել ca-cert.pem',
      caHint: 'Գրեք PEM-ը ca-cert.pem ֆայլում՝ մասնավոր պանակում, և միացեք nbds://…?tls-certificates=<պանակ> (nbdcopy, nbdinfo) կամ --object tls-creds-x509,dir=<պանակ>,endpoint=client (qemu-img) միջոցով',
      caAbsent: 'Նստաշրջանը CA չի կրում (PKI չկա)',
      openWrite: 'Բացել գրառման արտահանում',
      openWriteTitle: 'Բացել գրառման արտահանում',
      openWriteIntro: 'Սկավառակը պետք է անձեռնմխելի լինի՝ ծնված դատարկ, երբեք չգրված, առանց պատկերի. VM-ը կանգնեցված։ Վերականգնումը ԼՑՆՈՒՄ է սկավառակը, ոչ թե նորոգում։ Քանի դեռ նստաշրջանը բաց է, VM-ը չի գործարկվում, պատկեր չի վերցնում, չի կլոնավորվում, իսկ սկավառակը չի տեղափոխվում։',
      openWriteSubmit: 'Բացել',
      openWriteError: 'Գրառման արտահանումը չհաջողվեց բացել',
      openWriteDenied: 'Ձեզ պակասում է vm.restore.data այս VM-ում',
      openWriteStopped: 'Կանգնեցրեք VM-ը՝ գրառման արտահանում բացելու համար',
      fromDescription: 'Ստեղծել VM նկարագրությունից',
      fromDescriptionTitle: 'Ստեղծել VM նկարագրությունից',
      fromDescriptionIntro: 'export-vm-meta-ի նկարագրությունը վերադառնում է որպես կանգնեցված VM՝ նկարագրված երկրաչափության դատարկ սկավառակներով — պատրաստ գրառման արտահանումների համար՝ սկավառակ առ սկավառակ։ Բայթերն այստեղով չեն անցնում. դրանք տանում է restore-disk-ը (CLI) կամ պահուստավորման արտադրանքի NBD հաճախորդը։',
      fromDescriptionDoc: 'Նկարագրություն (JSON)',
      fromDescriptionDocHint: 'Տեղադրեք export-vm-meta փաստաթուղթը կամ ընտրեք ֆայլը',
      fromDescriptionFile: 'Ընտրել ֆայլ…',
      fromDescriptionInvalid: 'Տեքստը JSON փաստաթուղթ չէ',
      fromDescriptionName: 'Նոր VM-ի անունը',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ձեր սկզբնական scope-ը',
      fromDescriptionStorage: 'Սկավառակների պահոց',
      fromDescriptionStorageHint: 'Ամեն սկավառակ ծնվում է այստեղ՝ պահոցի լռելյայն ձևաչափով',
      fromDescriptionMetadataStorage: 'Մետատվյալների պահոց',
      fromDescriptionSameAsStorage: 'Նույնը, ինչ սկավառակներինը',
      fromDescriptionBridge: 'Կամուրջ',
      fromDescriptionBridgeHint: 'Առանց կամրջի կամ ցանցի VM-ը ծնվում է առանց ցանցային քարտերի',
      fromDescriptionNetwork: 'Տրամաբանական ցանց (fabric/ցանց)',
      fromDescriptionSubmit: 'Ստեղծել',
      fromDescriptionError: 'VM-ը չհաջողվեց ստեղծել',
      fromDescriptionDone: 'VM-ը ստեղծված է՝ {name}',
      fromDescriptionOpen: 'Բացել VM-ը',
      fromDescriptionDenied: 'Ձեզ պակասում է vm.create',
      fromDescriptionStillRunning: 'Ստեղծումը դեռ ընթանում է. շարունակում ենք սպասել'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'ՎՄ-ների տվյալների պահուստային պատճեններ',
      titleOnVm: 'Տվյալների պահուստային պատճեններ',
      empty:
        'Պատճեն չկա։ Պատճենը սկավառակները, UEFI varstore-ը և vTPM-ի վիճակը տեղափոխում է նշանակետ և գոյատևում է վիրտուալ մեքենայից հետո։',
      colVm: 'ՎՄ',
      colCreated: 'Վերցվել է',
      colPhase: 'Արդյունք',
      colDestination: 'Նշանակետ',
      colContains: 'Բովանդակություն',
      colSize: 'Չափ',
      colOrigin: 'Ծագում',
      colMode: 'Տեսակ',
      retentionChip: 'Պահպանում',
      retentionHint:
        'Նշանակետի պահպանման կանոնը կարող է ջնջել այս պատճենը առանց հարցնելու․ այն ծնվել է ժամանակացույցից։ Ձեռքով վերցրած պատճենները երբեք չեն մաքրվում։',
      policyRemoved: 'Policy-ն հեռացված է. {name}',
      policyRemovedHint:
        'Այս backup-ը պլանավորած policy-ն այլևս գոյություն չունի. ոչ մի retention այն չի կառավարում (երբեք ինքնաբերաբար չի էտվում) — ջնջեք այն ձեռքով, երբ այլևս պետք չէ:',
      phase: {
        running: 'Ընթացքում',
        complete: 'Ավարտված',
        error: 'Ձախողվել է'
      },
      origin: {
        manual: 'Ձեռքով',
        schedule: 'Ժամանակացույցով'
      },
      mode: {
        full: 'Լրիվ',
        incremental: 'Աճական'
      },
      contains: {
        disks: 'Սկավառակներ',
        varstore: 'UEFI varstore',
        vtpm: 'vTPM-ի վիճակ',
        snapshots: 'Ակնթարթներ'
      },
      vmState: {
        stopped: 'ՎՄ-ն անջատված',
        running: 'ՎՄ-ն աշխատում է (տաք)'
      },
      artifactClass: { metadata: 'Մետատվյալներ', data: 'Տվյալներ', secret: 'Գաղտնիք' },
      detail: {
        tabOverview: 'Ամփոփում',
        tabArtefact: 'Արտեֆակտ',
        id: 'Նույնացուցիչ',
        scope: 'Շրջանակ',
        vmState: 'ՎՄ-ի վիճակը պատճենման պահին',
        pointInTime: 'Տվյալների պահը',
        completedAt: 'Ավարտվել է',
        node: 'Պատճենող հանգույցը',
        error: 'Սխալ',
        path: 'Թղթապանակը պահոցում',
        checksum: 'manifest-ի sha256',
        secretsExposed: 'Զգայուն նյութ բաց տեսքով',
        secretsExposedYes: 'Այո — նշանակետը չի գաղտնագրում',
        secretsExposedNo: 'Ոչ',
        baseBackup: 'Հենքային պատճեն',
        tabManifest: 'Manifest',
        manifestHint:
          'Արտեֆակտի բաց ցուցիչը․ մեկ ֆայլ տողում՝ իր sha256-ով։ Թղթապանակը ստուգվում է նաև առանց TVirt-ի — բավական են qemu-img, tar և jq։',
        manifestEmpty: 'Manifest-ը ֆայլեր չի թվարկում։',
        manifestError: 'Manifest-ը ընթեռնելի չէ',
        colEntry: 'Ֆայլ',
        colClass: 'Դաս',
        colSha: 'sha256'
      },
      create: {
        action: 'Պատճենել հիմա',
        title: 'Պատճենել հիմա',
        submit: 'Սկսել պատճենումը',
        destination: 'Նշանակետ',
        destinationHint: 'Միայն այն նշանակետերը, որոնք ընդունում են պատճեններ։',
        noDestinations: 'Ոչ մի նշանակետ պատճեններ չի ընդունում․ ստեղծեք մեկը Համակարգ → Checkpoints բաժնում։',
        contentsHint:
          'Ճանապարհ են ընկնում բոլոր սկավառակները, UEFI varstore-ը և vTPM-ի վիճակը։ Վերջին երկուսը էությունն են․ կնքված հյուրը պետք է նորից բարձրանա։',
        error: 'Պատճենումը չմեկնարկեց',
        stillRunning: 'Պատճենումը դեռ ընթանում է — այն շարունակվում է, նույնիսկ եթե փակեք։',
        vmRunning:
          'Մեքենան {phase} է․ պահուստավորումը կայուն ՎՄ է պահանջում — անջատված՝ սառը պատճենի, աշխատող՝ տաքի համար։'
      },
      restore: {
        action: 'Վերականգնել',
        title: 'Վերականգնել',
        intro: 'Վերականգնումն անշրջելի է։ Ընտրեք, թե ուր են վերադառնում տվյալները․ նոր մեքենա, թե ելակետայինի վրա։',
        modeNewVm: 'Վերականգնել ՆՈՐ ՎՄ-ում',
        modeNewVmHint:
          'Ոչ մի գոյություն ունեցող բանի չի դիպչում — սա այն տարբերակն է, որով ստուգում են պատճենը։ Նոր նույնացուցիչ և թարմ հատած MAC-ներ։',
        modeOver: 'Վերագրել ելակետային ՎՄ-ի վրա',
        modeOverHint: 'Ոչնչացնում է թիրախ ՎՄ-ի ընթացիկ տվյալները՝ առանց հետդարձի։ Մեքենան պետք է անջատված լինի։',
        newName: 'Նոր ՎՄ-ի անունը',
        newNameHint: 'Այն պետք է ազատ լինի թիրախ շրջանակում։',
        storage: 'Սկավառակների պահոց',
        storageHint:
          'Պարտադիր է․ manifest-ը գրանցում է սկավառակի չափն ու ձևաչափը, բայց երբեք այն պահոցը, որտեղ այն կար։',
        metadataStorage: 'varstore-ի և vTPM-ի պահոց',
        metadataStorageHint: 'Ուր են վայրէջք կատարում UEFI ինքնությունը և vTPM-ի վիճակը։',
        sameAsStorage: 'Նույնը, ինչ սկավառակներինը',
        bridge: 'Հոսթի bridge',
        bridgeHint:
          'Յուրաքանչյուր գրանցված ցանցային քարտ վերադառնում է այս bridge-ի վրա նոր MAC-ով։ Դատարկ թողնելիս ՎՄ-ն ծնվում է առանց քարտերի — ավելի ապահով լռելյայն։',
        overwriteTitle: 'Դուք պատրաստվում եք վերագրել այս ՎՄ-ն',
        overwriteName: 'Անուն',
        overwriteId: 'Նույնացուցիչ',
        overwriteDisks: 'Սկավառակներ, որոնք կվերագրվեն',
        overwriteNoDisks: 'Սկավառակ չկա։',
        overwriteKeeps:
          'Անձեռնմխելի են մնում նույնացուցիչը, անունը, շրջանակը, ցանցային քարտերը և MAC-ները․ պատճենը ՏՎՅԱԼՆԵՐՆ են, կարգավորումը checkpoint-ն է։',
        confirmField: 'ՎՄ-ի անունը',
        confirmHint: 'Հաստատելու համար մուտքագրեք {name}։',
        targetLoading: 'Կարդացվում է թիրախ ՎՄ-ն…',
        targetRunning:
          'Թիրախ ՎՄ-ն {phase} է․ վերականգնումը վերագրում է հյուրի տակի բայթերը, ուստի պահանջում է այն անջատված։',
        targetGone: 'Ելակետային ՎՄ-ն այլևս ընթեռնելի չէ․ մնում է վերականգնումը նոր ՎՄ-ում։',
        onlyComplete: 'Պատճենը {phase} է․ վերականգնել կարող է միայն ավարտված պատճենը։',
        submitNewVm: 'Վերականգնել նոր ՎՄ-ում',
        submitOver: 'Վերագրել',
        error: 'Վերականգնումը չմեկնարկեց',
        stillRunning: 'Վերականգնումը դեռ ընթանում է — ամբողջ սկավառակներ պատճենելը ժամանակ է պահանջում։'
      }
    },
    guest: {
      title: {
        ct: 'Կոնտեյներների տվյալների պահուստներ',
        app: 'App-երի տվյալների պահուստներ'
      },
      tabTitle: 'Պահուստներ',
      empty: 'Պահուստներ չկան: Պահուստը կայուն տվյալները տեղափոխում է նշանակետ և ապրում է իր օբյեկտից երկար:',
      colSubject: {
        ct: 'Կոնտեյներ',
        app: 'App'
      },
      colCreated: 'Ստեղծվել է',
      colPhase: 'Արդյունք',
      colDestination: 'Նշանակետ',
      colContains: 'Բովանդակություն',
      colSize: 'Չափ',
      colOrigin: 'Ծագում',
      policyRemoved: 'Policy-ն հեռացված է. {name}',
      policyRemovedHint:
        'Այս backup-ը պլանավորած policy-ն այլևս գոյություն չունի. ոչ մի retention այն չի կառավարում (երբեք ինքնաբերաբար չի էտվում) — ջնջեք այն ձեռքով, երբ այլևս պետք չէ:',
      phase: {
        running: 'Ընթացքի մեջ',
        complete: 'Ավարտված',
        error: 'Ձախողված'
      },
      origin: {
        manual: 'Ձեռքով',
        schedule: 'Պլանավորված'
      },
      state: {
        stopped: 'Օբյեկտը կանգնեցված է',
        running: 'Օբյեկտն աշխատում է (սառեցված)'
      },
      contains: {
        rootfs: 'Rootfs ծառ',
        config: 'Կոնֆիգուրացիա',
        volumes: 'Կայուն ծավալներ',
        root: 'Կայուն root'
      },
      artifactClass: {
        metadata: 'Մետատվյալներ',
        data: 'Տվյալներ',
        secret: 'Գաղտնիք'
      },
      create: {
        action: 'Պահուստավորել հիմա',
        title: 'Նոր պահուստ',
        submit: 'Սկսել պահուստը',
        error: 'Պահուստը չսկսվեց',
        destination: 'Նշանակետ',
        destinationHint: 'Միայն այն նշանակետները, որոնք ընդունում են տվյալների պահուստներ:',
        noDestinations:
          'Ոչ մի նշանակետ չի ընդունում տվյալների պահուստներ. նշանակետին ավելացրեք «Տվյալների պահուստներ»:',
        hint: {
          ct: 'Ճամփորդում է ամբողջ rootfs ծառը՝ հավատարմորեն (թվային սեփականատերեր, xattr-ներ, ACL-ներ), գումարած հայտարարված կոնֆիգուրացիան մանիֆեստում: Աշխատող կոնտեյները ՍԱՌԵՑՎՈՒՄ Է փաթեթավորման ամբողջ ընթացքում. crash-consistent պատճեն՝ հայտարարված:',
          app: 'Ճամփորդում են ՄԻԱՅՆ կայուն ծավալները (և կայուն root-ը), գումարած կոնֆիգուրացիան մանիֆեստում: Անցողիկը բացառված է վավերացմամբ, և մանիֆեստը այն անվանում է. գաղտնի հայտարարված env արժեքները չեն ճամփորդում:'
        },
        stillRunning: 'Պահուստը դեռ ընթացքի մեջ է — ամբողջ ծառերի փաթեթավորումը ժամանակ է պահանջում:'
      },
      detail: {
        tabOverview: 'Ակնարկ',
        tabManifest: 'Մանիֆեստ',
        id: 'Նույնացուցիչ',
        scope: 'Շրջանակ',
        state: 'Վիճակը պատճենման պահին',
        pointInTime: 'Տվյալները պահին',
        completedAt: 'Ավարտվել է',
        node: 'Պատճենող հանգույց',
        error: 'Սխալ',
        path: 'Պանակ պահոցում',
        checksum: 'Մանիֆեստի sha256',
        manifestHint:
          'Արտեֆակտի ցուցիչը՝ մեկ գրառում յուրաքանչյուր ֆայլի համար՝ իր sha256-ով — առանց հեշերի «պահուստը կա»-ն հավատքի ակտ է:',
        manifestError: 'Մանիֆեստը հնարավոր չէ կարդալ',
        manifestEmpty: 'Մանիֆեստում արտեֆակտներ չկան:',
        colEntry: 'Ֆայլ',
        colClass: 'Դաս',
        colSha: 'sha256',
        excluded: 'Բացառված վավերացմամբ (չի ճամփորդում)',
        secretKeys: 'Բաց թողնված գաղտնի env բանալիներ (#307) — վերականգնումից հետո նորից մուտքագրեք'
      },
      restore: {
        action: 'Վերականգնել',
        title: 'Վերականգնում',
        submit: 'Վերականգնել',
        error: 'Վերականգնումը չսկսվեց',
        stillRunning: 'Վերականգնումը դեռ ընթացքի մեջ է — ամբողջ ծառերի բացումը ժամանակ է պահանջում:',
        onlyComplete: 'Պահուստը {phase} է. վերականգնել կարող է միայն ավարտված պահուստը:',
        asNew: {
          ct: 'ՆՈՐ կոնտեյների մեջ — ոչինչ չի ոչնչացնում. ժեստը, որով ստուգում են պահուստը',
          app: 'ՆՈՐ App-ի մեջ — ոչինչ չի ոչնչացնում. ժեստը, որով ստուգում են պահուստը'
        },
        over: {
          ct: 'Աղբյուր կոնտեյների ՎՐԱ — ամբողջ rootfs ծառը փոխարինվում է',
          app: 'Աղբյուր App-ի ՎՐԱ — յուրաքանչյուր կայուն ծավալի բովանդակությունը փոխարինվում է'
        },
        name: 'Նոր օբյեկտի անունը',
        storage: 'Պահոց',
        storageHint: 'Որտեղ են վայրէջք կատարում վերականգնված տվյալները — մանիֆեստը երբեք չի գրանցում կորած pool-ը:',
        storageDeclared: 'Մանիֆեստում հայտարարված պահոցները',
        bridge: 'Հոսթի կամուրջ',
        bridgeHint:
          'Յուրաքանչյուր գրանցված քարտ վերադառնում է այս կամրջին թարմ MAC-ով: Դատարկ = ծնվում է չմիացված՝ ամենաանվտանգ լռելյայնը:',
        node: 'Հանգույց',
        nodeHint: 'Անդամը, որի վրա App-ը վերածնվում է. հանգույցը կլաստերի ինքնություն է և երբեք չի գալիս մանիֆեստից:',
        secretKeysWarning:
          'Գաղտնի հայտարարված env արժեքները չեն ճամփորդում պահուստում. վերածնված պատճենը դրանք նորից է ուզում (task-ի մատյանը անվանում է բանալիները):',
        overInventory: 'Դուք պատրաստվում եք վերագրանցել այս օբյեկտը',
        confirmType: 'Հաստատելու համար մուտքագրեք {name}',
        targetGone: 'Աղբյուր օբյեկտն այլևս հնարավոր չէ կարդալ. մնում է վերականգնումը որպես նոր:',
        targetLoading: 'Թիրախ օբյեկտի ընթերցում…',
        targetRunning:
          'Թիրախ օբյեկտն աշխատում է. վերականգնումը փոխարինում է բայթերը հյուրի տակ և ուզում է այն կանգնեցված:'
      }
    }
  }
}
